import React, { useState } from 'react';
import './AnnouncementBanner.css';
import { Container, Row, Col, Button } from 'react-bootstrap';

const AnnouncementBanner = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <section className="announcement-section" role="status" aria-live="polite">
      <div className="gn-container">
        <Row className="align-items-center g-3">
          <Col md={1} xs={2} className="text-md-start text-center">
            <div className="announce-icon" aria-hidden="true">★</div>
          </Col>
          <Col md={9} xs={10}>
            <div className="announce-content">
              <span className="announce-eyebrow">Holiday notice</span>
              <h3 className="announce-title">Veterans Day hours</h3>
              <p className="announce-desc">
                GN bank will be closed on Tuesday, November 11, 2025. We will reopen Wednesday, November 12, 2025, during our regular business hours.
              </p>
            </div>
          </Col>
          <Col md={2} className="text-md-end text-center">
            <div className="announce-actions">
              <Button className="btn-gn-secondary me-2" href="/location">Find ATM</Button>
              <button className="announce-dismiss" onClick={() => setVisible(false)} aria-label="Dismiss announcement">Dismiss</button>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default AnnouncementBanner;


